import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { trellisPalette } from "./palettes";
import { Chart } from "@highcharts/react";
import { formatPercent } from "../../../utils/formatNumber";

const MAX_BRANDS = 5;

const TimelineView = ({ timelineData, shelfStatsTotalData, share, homeBrand }) => {
  const { t } = useTranslation(["analytics"]);
  const [dates, series] = useMemo(() => {
    const key = {
      total: "share_of_shelf",
      organic: "org_share_of_shelf",
      sponsored: "share_of_voice",
    }[share];
    let dates = timelineData.map((entry) => entry.date);
    dates = [...new Set(dates)].reverse();
    const byBrand = timelineData.reduce((acc, entry) => {
      if (!acc[entry.brand]) {
        acc[entry.brand] = [];
      }
      acc[entry.brand].push(entry);
      return acc;
    }, {});
    const series = Object.entries(byBrand).map(([brand, entries]) => {
      const data = dates.map((date) => {
        const entry = entries.find((entry) => entry.date === date);
        return entry?.[key] || 0;
      });
      return { brand, data: data };
    });
    // Sort total data by share of shelf or voice and make sure the home brand is first
    const sortedTotalData = shelfStatsTotalData.sort((a, b) => {
      if (homeBrand === a.brand) return -1;
      if (homeBrand === b.brand) return 1;
      return b[key] - a[key];
    });
    const topN = sortedTotalData.slice(0, MAX_BRANDS);

    return [
      dates,
      topN.map(({ brand }) => {
        return {
          name: brand,
          data: series.find(({ brand: b }) => b === brand)?.data || [],
        };
      }),
    ];
  }, [shelfStatsTotalData, timelineData, share, homeBrand]);

  const options = {
    colors: trellisPalette,
    title: { text: "" },
    yAxis: {
      title: {
        text: t(($) => $.analytics.timelineView.Share),
      },
    },
    xAxis: {
      categories: dates,
    },
    chart: {
      height: "530px",
      type: "line",
      style: {
        fontFamily: "Poppins",
        fontWeight: "300",
        fontSize: "15px",
      },
    },
    tooltip: {
      formatter: function () {
        return `${this.series.name}: ${formatPercent(this.point.y / 100)}`;
      },
    },
    series: series,
  };

  return (
    <div>
      <Chart options={options} />
    </div>
  );
};

export default TimelineView;
